// prop-type is a library for typechecking of props
/* eslint-disable */
import { useState, useCallback } from "react";
import { TextField, MenuList, MenuItem } from "@mui/material";
import PlacesAutocomplete from "react-places-autocomplete";
import Loading from "components/NewLoading";

function Search({ onChange }) {
  const [search, setSearch] = useState("");

  const onSelect = useCallback(
    (s) => {
      setSearch(s);
      if (onChange) {
        onChange(s);
      }
    },
    [onChange]
  );

  const renderMenuContent = useCallback(
    (loading, suggestions, getSuggestionItemProps) => {
      if (loading) {
        return (
          <MenuItem style={{ display: "flex", justifyContent: "center" }}>
            <Loading className="grey" />
          </MenuItem>
        );
      } else {
        if (search) {
          if (suggestions.length > 0) {
            return suggestions.map((suggestion) => (
              <MenuItem
                key={suggestion.placeId}
                {...getSuggestionItemProps(suggestion)}
                style={{
                  display: "block",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {suggestion.description}
              </MenuItem>
            ));
          } else {
            // return (
            //   <MenuItem style={{ display: "flex", justifyContent: "center" }}>
            //     No places found
            //   </MenuItem>
            // );
            return null;
          }
        }
      }
    },
    [search]
  );

  return (
    <PlacesAutocomplete value={search} onChange={setSearch} onSelect={onSelect}>
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div style={{ position: "relative" }}>
          <TextField {...getInputProps({ label: "Search Places" })} style={{width: '100%'}} />

          <MenuList
            style={{
              position: "absolute",
              zIndex: 20,
              marginTop: 4,
              left: 0,
              right: 0,
              background: "white",
              border: loading || suggestions.length > 0 ? "1px solid #d2d6da" : undefined,
              borderRadius: 5,
            }}
          >
            {renderMenuContent(loading, suggestions, getSuggestionItemProps)}
          </MenuList>
        </div>
      )}
    </PlacesAutocomplete>
  );
}

export default Search;
